import { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@mui/material";

/**
 * @param {{ text?: string | JSX.Element, cancelText?: string, isOpen?: boolean, onClose?: () => void, onConfirm?: () => void, onCancel?: () => void }} props 
 * @returns 
 */
const ConfirmDialog = (props) => {
  const { isOpen, text, onClose, onConfirm, onCancel } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (text) setOpen(true);
  }, [text]);

  useEffect(() => {
    if (isOpen) setOpen(true);
    else setOpen(false);
  }, [isOpen]);

  return (
    <>
      <Dialog
        open={open}
        keepMounted
        onClose={() => {
          setOpen(false);
          onClose && onClose();
        }}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        className="confirm-dialog"
      >
        <DialogContent>
          <div className="confirm-dialog-text">
            {text}
          </div>
          <div className="confirm-dialog-buttons">
            <button onClick={() => {
              setOpen(false);
              onCancel && onCancel();
            }}>{props.cancelText ?? 'Cancel'}</button>
            <button onClick={() => {
              setOpen(false);
              onConfirm && onConfirm();
            }}>OK</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ConfirmDialog;
